module.exports = "./img/4ae9e2b236fcd341a7e3c2919f278acb.jpg";